// Social profiles are intentionally disabled until each official URL is verified.
// Never fall back to a platform homepage: that sends customers to the wrong destination.
export const SOCIAL_LINKS = [
  { id: "instagram", label: "Instagram", href: "", enabled: false },
  { id: "facebook", label: "Facebook", href: "", enabled: false },
  { id: "youtube", label: "YouTube", href: "", enabled: false },
  { id: "tiktok", label: "TikTok", href: "", enabled: false },
  { id: "x", label: "X", href: "", enabled: false },
  { id: "whatsapp", label: "WhatsApp", href: "", enabled: false },
];

export const ACTIVE_SOCIAL_LINKS = SOCIAL_LINKS.filter(
  ({ enabled, href }) => enabled && /^https:\/\//i.test(href)
);
